import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import * as serviceWorker from './serviceWorker';
import "./styles/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

serviceWorker.unregister();